
import apiConstents from "views/eywafarm/CropHealth/utils/constent"
import ApiService from "./ApiService"

// for Problem Groups

export async function apiGetProblemGroupsList() {
    return ApiService.fetchData({
        url: `problem-groups?${apiConstents.problemPopulate}${apiConstents.problemListSort}&${apiConstents.allDataLimit}`,
        method: 'get',
    })
}

export async function apiGetProblemGroupsPrtnerList(partnerId) {
    return ApiService.fetchData({
        url: `drfchp-problem-groups${apiConstents.populateProblemGroup}${apiConstents.partnerFilter}${partnerId}${apiConstents.problemSort}&${apiConstents.allDataLimit}`,
        method: 'get',
    })
}

export async function apiPublishProblemGroup(data) { 
    return ApiService.fetchData({
        url: `chp/clone-to-published`,
        method: 'post',
        data
    })
}

export async function apiCheckProblemGroups(id,partnerId) {
    return ApiService.fetchData({
        url: `drfchp-problem-groups${apiConstents.checkProblemPopulatePartner}${apiConstents.checkProblemFilter}${id}${apiConstents.checkProblemFilter2}${partnerId}`,
        method: 'get',
    })
}

export async function apiCreateProblemGroups(data) {
    return ApiService.fetchData({
        url: `drfchp-problem-groups`,
        method: 'post',
        data
    })
}

export async function apiGetProblemTimelinesList(id,partnerId) {
    return ApiService.fetchData({
        url: `drf-part-pg-tls${apiConstents.timelineSort}${apiConstents.timelineFilter}${id}&${apiConstents.timelinePartnerFilter}${partnerId}&${apiConstents.allDataLimit}`,
        method: 'get',
    })
}

export async function apiUpdateTimelineProbleStatus(id, data) {
    return ApiService.fetchData({
        url: `drf-part-pg-tls/${id}`,
        method: 'put',
        data
    })
}

export async function apiAddTimelineProblemGroup(data) {
    return ApiService.fetchData({
        url: `drf-part-pg-tls`,
        method: 'post',
        data
    })
}

export async function apiGetSingleTimelineProblem(id) {
    return ApiService.fetchData({
        url: `drf-part-pg-tls/${id}${apiConstents.populateChpProblemGroup}`,
        method: 'get',
    })
}

export async function apiUpdateTimelineProblem(id, data) {
    return ApiService.fetchData({
        url: `drf-part-pg-tls/${id}`,
        method: 'put',
        data
    })
}

export async function apiDeleteTimelineProblem(id) {
    return ApiService.fetchData({
        url: `drf-part-pg-tls/${id}`,
        method: 'delete'
    })
}


export async function apiGetGlobalSyncTimeline(id, data ){ 
    return ApiService.fetchData({
        url: `partner-pg-timelines/${id}/globalSync`,
        method: 'post',
        data
    })
}

export async function apiGetLastGlobalSyncDate(chpId, data) {
    return ApiService.fetchData({
        url: `problem-group-sync/${chpId}/time`,
        method: 'put',
        data
    })
}

export async function apiGetValidProblemTimelineName(name, problemId) {
    return ApiService.fetchData({
        url:`drf-part-pg-tls${apiConstents.filetrTimelineName}${name}${apiConstents.filetrProblemTimelinePartner}${problemId}`,
        method: 'get',
    })
}

export async function apiGetPGHistoryList(query) {
    return ApiService.fetchData({
        url: `pg/packages/get/json-versions?chpProblemGroupId=${query.PGID}&draftchpProblemGroupId=${query.draftPGID}`,
        method: 'get',
    })
}

export async function apiRestorePGVersion(data){
    return ApiService.fetchData({
        url: `chpProblemGroup/retreive/previous-version`,
        method: 'post',
        data
    })
}

// specific problem

export async function apiGetProblemGroupCrop() { 
    return ApiService.fetchData({
        url: `crop-connects?${apiConstents.allDataLimit}`,
        method: 'get',
    })
}

export async function apiGetCropHealthCropList(partnerId) {
    return ApiService.fetchData({
        url: `partner/get/${partnerId}/cropHealth`,
        method: 'get',
    })
}

export async function apiGetSpecificProblemOption(cropId) { 
    return ApiService.fetchData({
        url: `specific-problems${apiConstents.specificCropFilter}${cropId}&${apiConstents.allDataLimit}`,
        method: 'get',
    })
}

export async function apiAddCropHealth(data) { 
    return ApiService.fetchData({
       url: `drf-partner-spgs`,
        method: 'post',
        data
    })
}

export async function apiGetSpecificProblemList(partnerId) { 
    return ApiService.fetchData({
      url: `drf-partner-spgs${apiConstents.specificPopulate}${apiConstents.partnerFilter}${partnerId}${apiConstents.specificSort}&${apiConstents.allDataLimit}`,
        method: 'get',
    })
}

export async function apiUpdateSpecificProblem(id, data) { //
    return ApiService.fetchData({
        url: `drf-partner-spgs/${id}`,
        method: 'put',
        data
    })
}

export async function apiGetSpecificProblemTimelineList(id) {
    return ApiService.fetchData({
       url: `drf-part-spg-tls${apiConstents.specificTimelineFilter}${id}${apiConstents.specificTimelinePopulate}${apiConstents.specificSort}&${apiConstents.allDataLimit}`,
        method: 'get',
    })
}

export async function apiAddSpecificTimeline(data) {
    return ApiService.fetchData({
      url: `drf-part-spg-tls`,
        method: 'post',
        data
    })
}

export async function apiUpdateSpecificTimeline(id, data) {
    return ApiService.fetchData({
     url: `drf-part-spg-tls/${id}`,
        method: 'put',
        data
    })
}
export async function apiDeleteSpecificTimeline(id) {
    return ApiService.fetchData({
        url: `drf-part-spg-tls/${id}`,
        method: 'delete'
    })
}
export async function apiGetSingleSpecificProblemTimeline(id) {
    return ApiService.fetchData({
        url: `drf-part-spg-tls/${id}${apiConstents.populateSpecificProblem}`,
        method: 'get',
    })
}

export async function apiGetLocalSyncSpecificTimeline(data ){ 
    return ApiService.fetchData({
        url: `partner-spg-timelines/localSync`,
        method: 'post',
        data
    })
}

export async function apiGetLastLocalSyncDate(id,data) {
    return ApiService.fetchData({
        url: `specific-problem-group-sync/${id}/localTime`,
        method: 'put',
        data
    })
}

export async function apiGetValidTimelineName(name, problemId) {
    return ApiService.fetchData({
        url: `drf-part-spg-tls${apiConstents.filetrTimelineName}${name}${apiConstents.filetrTimelineName2}${problemId}`, //part-spg-tls?filters[$and][0][name][$eq]=%20%20chilli%20expert&filters[$and][1][partner_spg][id][$eq]=85
        method: 'get',
    })
}
export async function apiGetSPGHistoryList(query) { 
    return ApiService.fetchData({
        url: `spg/packages/get/json-versions?SpgProblemGroupId=${query.SPGID}&draftSpgProblemGroupId=${query.draftSPGID}`,
        method: 'get',
    })
}

export async function apiRestoreSPGVersion(data){
    return ApiService.fetchData({
        url: `spgProblemGroup/retreive/previous-version`,
        method: 'post',
        data
    })
}

export async function apiPublishSPGCloneToPublished(data){
    return ApiService.fetchData({
        url: `spg/clone-to-published`,
        method: 'post',
        data
    })
}
